import { Component, Input } from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { OrderPercentagesDisplayed } from '@shared/models/percentages-displayed-model';

@Component({
  selector: 'app-order-percentages-bar',
  templateUrl: './order-percentages-bar.component.html',
  styleUrls: ['./order-percentages-bar.component.scss'],
})
export class OrderPercentagesBarComponent {
  @Input() data: OrderPercentagesDisplayed;

  constructor(public platformService: PlatformService) {}
}
